import React from "react";
import { useUserInfo } from "../../contexts/user";
import { useLexisHistory } from "contexts/lexisHistory";
import { Link } from "react-router-dom";
import LNLogo from "../common/LNLogo";

const currentDateTime = new Date();

export default function LexisNexisPDFTitlePage() {
  return (
    <div className="title-page">
      <dl className="inline-dl">
        <dt>User:</dt>
        <dd>{useUserInfo().primaryEmail}</dd>

        <dt>Date and Time:</dt>
        <dd>
          {currentDateTime.toDateString()} {currentDateTime.toTimeString()}
        </dd>
      </dl>

      <h1>
        <Link
          key={"landingPageH1Link"}
          to={window.location.pathname}
          data-absolute-href={window.location.href}
        >
          {useLexisHistory().pageTitle}
        </Link>
      </h1>

      <footer>
        <ul className="lm-list-inline">
          <li>
            {" "}
            <LNLogo />
          </li>
          <li>
            <a href="https://www.lexisnexis.com/en-us/about-us/about-us.page">
              About LexisNexis
            </a>
          </li>
          <li>
            <a href="http://www.lexisnexis.com/en-us/terms/privacy-policy.page">
              Privacy Policy
            </a>
          </li>
          <li>
            <a href="http://www.lexisnexis.com/terms/general.aspx">
              Terms & Conditions
            </a>
          </li>
          <li>Copyright &copy; {currentDateTime.getFullYear()} LexisNexis</li>
        </ul>
      </footer>
    </div>
  );
}
